import rootService from 'core/services.root';

export default rootService({
    sendError: ['POST', '/global/error']
});
